import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import EditIcon from '@material-ui/icons/Edit';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import { NAME_SPACE } from 'i18n';
import { ViewTable, execConfirmModal, ButtonAdd, ButtonDelete } from 'shared';
import { PATH } from 'app.routes.const';
import { useListHtmlTemplatesStyles } from './listHtmlTemplates.styles';
import { useHtmlTemplatesPaginated } from './useHtmlTemplatesPaginated';
import { useHtmlTemplatesBuildTable } from './useHtmlTemplatesBuildTable';

export function ListHtmlTemplates() {
  const classes = useListHtmlTemplatesStyles();
  const { htmlTemplates, getHtmlTemplates, deleteHtmlTemplates, copyHtmlTemplate, errorInfo } =
    useHtmlTemplatesPaginated();
  const { t } = useTranslation(NAME_SPACE.HTML_TEMPLATES);
  const history = useHistory();

  const { rows, headCells } = useHtmlTemplatesBuildTable(htmlTemplates, t);

  function handleEdit([htmlTemplateId]) {
    history.push(PATH.HTML_TEMPLATES.EDIT.replace(':id', htmlTemplateId));
  }

  function handleAdd() {
    history.push(PATH.HTML_TEMPLATES.CREATE);
  }

  async function handleDelete(htmlTemplatesToDelete) {
    try {
      await execConfirmModal({
        title: t('common:actions.remove'),
        description:
          htmlTemplatesToDelete.length > 1
            ? t('removeConfirm.message', { length: htmlTemplatesToDelete.length })
            : t('removeConfirm.singularMessage', {
                name: htmlTemplatesToDelete[0].name
              }),
        confirmText: t('common:actions.accept'),
        declineText: t('common:actions.cancel'),
        confirmClassName: classes.buttonAdd,
        declineClassName: classes.buttonDelete
      });
      await deleteHtmlTemplates(htmlTemplatesToDelete);
    } catch (err) {}
  }

  async function handleCopy([stickerId]) {
    await copyHtmlTemplate(stickerId);
  }

  return (
    <div className={classes.htmlTemplates}>
      <ViewTable
        elevation
        spaced
        errors={errorInfo}
        rows={rows}
        cells={headCells}
        defaultOrderBy={{ property: 'name', direction: 'asc' }}
        mainKey={'name'}
        onFetchData={getHtmlTemplates}
        totalRows={htmlTemplates.total}
        serverSidePaging
        emptyText={t('empty')}
        actions={[
          {
            title: t('actions.edit'),
            name: 'edit',
            properties: ['id'],
            label: 'edit this row',
            cb: handleEdit,
            icon: <EditIcon />
          },
          {
            title: t('actions.copy'),
            name: 'copy',
            properties: ['id'],
            label: 'copy this row',
            cb: handleCopy,
            icon: <FileCopyIcon />
          }
        ]}
        toolbar={{
          title: t('name'),
          actions: [
            {
              condition: isAnySelected => !isAnySelected,
              cb: handleAdd,
              component: ButtonAdd
            },
            {
              condition: isAnySelected => isAnySelected,
              resetOnCB: true,
              cb: handleDelete,
              component: ButtonDelete
            }
          ]
        }}
      />
    </div>
  );
}
